import { jsxs as o, jsx as l } from "react/jsx-runtime";
const c = (r) => /* @__PURE__ */ o(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...r,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m19.634 41.448-1.998.54V22.55l1.998-.54v19.438ZM28.418 41.448l-1.998.54V22.55l1.997-.54v19.438ZM37.2 41.448l-1.997.54V22.55l1.998-.54v19.438ZM43.893 24.24c1.54 1.13 3.606 1.804 5.525 1.804 1.919 0 4.015-.648 5.523-1.734 1.354-.975 2.97-2.797 2.97-5.94 0-2.296-1.404-5.056-4.172-8.202-2.041-2.32-4.112-4.005-4.132-4.022l-.19-.155-.19.158a40.952 40.952 0 0 0-4.13 4.09c-2.767 3.176-4.17 5.912-4.17 8.132 0 3.05 1.613 4.874 2.966 5.868Zm8.28-12.693c1.105 1.257 1.979 2.455 2.596 3.561.7 1.252 1.053 2.349 1.053 3.262 0 1.813-.707 3.24-2.1 4.243a7.001 7.001 0 0 1-2.121 1.015 7.835 7.835 0 0 1-2.182.325 7.278 7.278 0 0 1-2.157-.344 7.282 7.282 0 0 1-2.132-1.056c-.656-.482-1.168-1.055-1.52-1.704-.394-.725-.594-1.56-.594-2.48 0-.865.35-1.93 1.042-3.164.615-1.099 1.486-2.3 2.59-3.567a39.167 39.167 0 0 1 2.786-2.874c.726.666 1.735 1.64 2.74 2.782l-.002.001Z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m50.75 21.808-.435-1.95-.01.002a2.076 2.076 0 0 0 1.55-2.03l1.996.054c-.069 2.572-2.059 3.691-3.1 3.924ZM57.97 24.157a9.263 9.263 0 0 1-1.861 1.774c-.642.462-1.365.856-2.134 1.177v20.874l3.996-1.071V24.157Z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M10.024 16.017h29.253c.361-1.257 1.002-2.585 1.931-3.995H9.524a3.496 3.496 0 0 0-3.496 3.496V48.48a3.496 3.496 0 0 0 3.496 3.496h45.522l-1.07-3.995H10.023V16.017Z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M43.986 26.646v15.342l1.998-.541v-13.96a11.946 11.946 0 0 1-1.998-.84Z"
        }
      )
    ]
  }
);
export {
  c as ExternalDrains
};
